import React from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { getBrowseDeviationStreamId } from '../../../helpers';
import DeviationSelector from '../';
import SearchInput from '../../../_partials/SearchInput';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import { getDeviationsByIds } from '../../../../redux/deviations/selectors';
import { useSearch } from '../../../_hocs/withSearch';
import NoSearchResults from '../../../_partials/NoSearchResults';
import { fetchMoreBrowseDeviations } from '../../../actions';
import { useMMSelector, useMMDispatch } from '../../../_hocs/withOwnReduxStore';
import { selectors } from '../../../../Stream';

export type Props = {};

const BrowseDeviationSelector: React.FC<Props> = () => {
  const { searchQuery } = useSearch();
  const dispatch = useMMDispatch();

  const streamId = getBrowseDeviationStreamId(searchQuery);
  const deviations = useMMSelector(state =>
    getDeviationsByIds(state, selectors.getItems(state, streamId))
  );
  const isFetching = useMMSelector(state =>
    selectors.isFetching(state, streamId)
  );
  const hasMore = useMMSelector(state => selectors.hasMore(state, streamId));
  const isInitialized = useMMSelector(state =>
    selectors.isInitialized(state, streamId)
  );

  const fetchMoreIfNeeded = () => {
    if (!hasMore || isFetching) {
      return;
    }
    dispatch(fetchMoreBrowseDeviations());
  };

  const renderContent = () => {
    if (searchQuery && !deviations.length && isInitialized && !isFetching) {
      return <NoSearchResults />;
    }
    return (
      <>
        {isInitialized && deviations.length > 0 && (
          <DeviationSelector deviations={deviations} />
        )}
        {(!isInitialized || isFetching) && (
          <LoadingIndicator view="daSymbol" coverMode={!hasMore} />
        )}
      </>
    );
  };

  return (
    <PopupInnerLayout
      headerExtrasBottomZone={<SelectedItemsPanel />}
      headerExtrasRightZone={<SearchInput allowSearchByUrl />}
      scrollableContent={renderContent()}
      onScrolledToBottom={fetchMoreIfNeeded}
      onNotScrollable={fetchMoreIfNeeded}
    />
  );
};

export default BrowseDeviationSelector;
